module.exports = __webpack_public_path__ + "static/img/14002004.256b4023.png";